import { combineReducers } from 'redux';
import { RootState } from '../../@types/RootState';
import basicConfig from './basicConfig/root';
import channels from './channels';
import dadosInfopanel from './dadosInfopanel';
import lastIntegrationDate from './lastIntegrationDate';
import storesAndClusters from './storesAndClusters/root';

const reducers = combineReducers({
  dadosInfopanel,
  lastIntegrationDate,
  channels,
  basicConfig,
  storesAndClusters,
});

export type ReducerIpaProps = ReturnType<typeof reducers>;

export const selector = (state: RootState) => state.reducerIPA;

export default reducers;
